import React from 'react'
import { useSelector } from 'react-redux'

import styles from './clientListContainer.module.scss'
import { getAuthIsLTSupervisor, getAuthSupervisorSelectedProviderId } from '../../../data/auth/authSelectors'
import ClientListV3 from '../clientList/v3/ClientListV3'

const Clients: React.FC = () => {
  const isSupervisor = useSelector(getAuthIsLTSupervisor)
  const supervisorSelectedProviderId = useSelector(getAuthSupervisorSelectedProviderId)

  if (isSupervisor && !supervisorSelectedProviderId) {
    return <div className={styles.supervisor}>Please select a provider from the dropdown above.</div>
  }

  return <ClientListV3 />
}

export default Clients
